import { pick } from 'ramda'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'
import { parseComponentTypes } from '@/utils'
import { ComponentType } from '@/utils/api'

import { SentimentCheckSettings } from '../../types/customComponents'

export type sentimentCheckData =
  | { settings: SentimentCheckSettings }
  | string
  | null
  | undefined

export const parseSentimentCheckData = (
  orgSlug?: string,
  param?: sentimentCheckData
) => {
  if (!orgSlug || !param) return {}
  const data = parseComponentTypes(param, ComponentType.sentimentCheck)
  if (!data) return {}
  const filteredSettings = pick(
    [
      'SentimentPrompt',
      'PosButtonText',
      'NegButtonText',
      'PosButtonValue',
      'NegButtonValue',
      'CollectOpenFeedback',
      'PosResponse',
      'NegResponse',
      'OpenFeedbackPrompt',
    ],
    data.settings
  )
  return {
    data: {
      ...filteredSettings,
      FeedbackFrequency: 'ONCE_PER_SESSION', // TODO: Add vail UI
    },
    organization: orgSlug,
    schemaName: 'SentimentCheckConfig',
    schemaVersion: '1.1.0',
    version: '1.0.0',
  }
}

export const useParseSentimentCheckData = (
  orgSlug?: string,
  param?: sentimentCheckData
) => useMemo(() => parseSentimentCheckData(orgSlug, param), [param, orgSlug])

export const ConfigData = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)
  const current = useGetCustomComponent<SentimentCheckSettings>(componentID)

  const config = useParseSentimentCheckData(org.data?.slug, current.data)
  const valid = useValidateEndpoint(config, componentID)
  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName="Sentiment Check"
      valid={valid}
    />
  )
}
